import React from 'react';
import { Link } from '@ktag/styleguide/dist/react';
import { Eigentuemer, Eigentum, Result } from '../api/useLandowners';
import { LandownerNavigation } from '../api/contract';

interface LandownerGrundstueckProps {
  landownerNavigation: LandownerNavigation[];
  result: Result;
  linkClicked: () => void;
}

const LandownerGrundstueck = ({
  result,
  landownerNavigation,
  linkClicked,
}: LandownerGrundstueckProps) => {
  const getLevel = () => {
    const last = landownerNavigation.at(-1);
    return last ? last.level + 1 : 0;
  };

  const getArtText = (art: string | null) => {
    return art ? ` (${art}) ` : '';
  };

  const getLinkText = (eigentum: Eigentum) => {
    return `Anteil ${eigentum.anteilZaehler}/${eigentum.anteilNenner}${getArtText(
      eigentum.art,
    )}`;
  };

  const handleLinkClick = (eigentuemer: Eigentuemer, eigentum: Eigentum) => {
    const newLevel = getLevel();
    const newNavigationItem = {
      level: newLevel,
      egrid: eigentuemer[0].eGrid,
      landownerResponse: null,
      text: getLinkText(eigentum),
    };
    landownerNavigation.push(newNavigationItem);
    linkClicked();
  };

  return (
    <div className="grundstueck">
      <div className="numbered" />
      <div>
        {`${result.eigentum.bezeichnung.replace('/', ' ')} `}
        <Link
          text={getLinkText(result.eigentum)}
          onClickMethod={() => handleLinkClick(result.eigentuemer, result.eigentum)}
        />
      </div>
    </div>
  );
};

export default LandownerGrundstueck;
